import React, { useState } from "react"
import logo from "../../images/site_logo.png"
import { FaBars } from "react-icons/all"
import scrollTo from "gatsby-plugin-smoothscroll"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)


  return (
    <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
      <div className="container">
        <div className="navbar-brand">
          <img src={logo} width="30" height="30"
               className="d-inline-block align-top mr-2" alt="Safe Passage for Wildlife" />Safe Passage for Wildlife
        </div>
        <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                aria-label="Toggle navigation" onClick={() => setIsOpen(!isOpen)}>
          <FaBars />
        </button>
        <div className={`${isOpen ? "" : "collapse bg-brown"}  navbar-collapse`} id="navbarResponsive">
          <ul className={`${isOpen ? "nav-list bg-highlight" : ""} navbar-nav ml-auto text-center`}>
            <li className="nav-link font-weight-bold uppercase text-white"
                onClick={() => scrollTo("#about")}>About
            </li>
            <li className="nav-link font-weight-bold uppercase text-white"
                onClick={() => scrollTo("#campaign")}>Campaign
            </li>
            <li className="nav-link font-weight-bold uppercase text-white"
                onClick={() => scrollTo("#newsletter")}>Newsletter
            </li>
            {/*<li className="nav-link font-weight-bold uppercase text-white"*/}
            {/*    onClick={() => scrollTo("#accident")}>Report*/}
            {/*  Road*/}
            {/*  Accident*/}
            {/*</li>*/}
            <li className="nav-link font-weight-bold uppercase text-white"
                onClick={() => scrollTo("#team")}>Team
            </li>
            <li className="nav-link font-weight-bold uppercase text-white"
                onClick={() => scrollTo("#contact")}>Contact
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
